<template>
  <transition name="quick-slide">
    <div v-if="isVisible" class="floating-quick">
      <router-link to="/reservation/register" class="quick-btn register">
        <svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM12 14c-4.418 0-8 1.79-8 4v2h16v-2c0-2.21-3.582-4-8-4z"/>
          <path d="M19 8v6M22 11h-6" stroke-linecap="round"/>
        </svg>
        <span>관심고객등록</span>
      </router-link>
      <router-link to="/location/direction" class="quick-btn direction">
        <svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
          <circle cx="12" cy="9" r="2.5"/>
        </svg>
        <span>오시는길</span>
      </router-link>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'FloatingQuickMenu',
  data() {
    return {
      currentSection: 0
    }
  },
  computed: {
    isVisible() {
      return this.currentSection >= 1
    }
  },
  mounted() {
    window.addEventListener('section-change', this.onSectionChange)
  },
  beforeUnmount() {
    window.removeEventListener('section-change', this.onSectionChange)
  },
  methods: {
    onSectionChange(e) {
      this.currentSection = e.detail
    }
  }
}
</script>

<style scoped>
.floating-quick {
  position: fixed;
  right: 32px;
  bottom: 32px;
  z-index: 900;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.quick-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 50px;
  text-decoration: none;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.3px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.quick-btn.register {
  background: var(--thehue-primary);
  color: #fff;
}

.quick-btn.register:hover {
  background: var(--thehue-primary-dark);
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 69, 56, 0.3);
}

.quick-btn.direction {
  background: #fff;
  color: #333;
  border: 1px solid #e0e0e0;
}

.quick-btn.direction:hover {
  background: #f5f5f5;
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
}

.btn-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* 슬라이드 애니메이션 */
.quick-slide-enter-active {
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.4s ease;
}

.quick-slide-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.quick-slide-enter-from {
  transform: translateY(20px);
  opacity: 0;
}

.quick-slide-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

/* 모바일 숨김 */
@media (max-width: 768px) {
  .floating-quick {
    display: none;
  }
}
</style>
